// The five playable classes, in the order the in-game selector shows them.
// This cannot live in CharsFilterClient.jsx: every export of a `'use client'`
// module becomes a client reference, so a Server Component may not read one.
export const CHARS = [
  { key: 'razboinic', image: 'https://metin2-history.b-cdn.net/War.png' },
  { key: 'ninja', image: 'https://metin2-history.b-cdn.net/Ninja.png' },
  { key: 'sura', image: 'https://metin2-history.b-cdn.net/Sura.png' },
  { key: 'saman', image: 'https://metin2-history.b-cdn.net/Shaman.png' },
  { key: 'lycan', image: 'https://metin2-history.b-cdn.net/Lycan.png' },
]

// Dispatched on `window` after the `data.char` query parameter changes without
// a navigation React can see (`replaceState`, or a soft push to the same page).
// CharsFilterClient re-reads the URL when it fires.
export const CHARS_FILTER_CHANGE_EVENT = 'charsfilter:change'

// Categories that open on one class instead of on the full list, keyed by
// slug. Static on purpose rather than an `inCategoryItems.meta` flag: the
// category page is prerendered output, so the default has to be known without
// a per-request read, and baking it in is what lets the right cards paint
// before hydration. A visitor arriving with an explicit `?data.char=…` always
// wins over it.
export const DEFAULT_CHAR_BY_CATEGORY = {
  frizuri: 'razboinic',
}

export function getDefaultChar(slug) {
  const key = DEFAULT_CHAR_BY_CATEGORY[slug]
  return CHARS.some((c) => c.key === key) ? key : null
}
